<template>
    <div style="padding-top:50px;min-height:90vh;">
      <div class="section">
        <div class="req-title"><span class="asterisk">*</span> 请选择你想投诉的问题</div>
        <div class="desc-tip">本次举报提供的所有信息，仅用于该投诉的专属处理流程，绝不会向任何第三方泄露。投诉举报经核实事实成立的，有现金奖励，价值越大奖励越高。</div>

        <div style="margin-left: 11px; display: flex;flex-direction: column;">
          <ToggleRadioItem :name="1" v-model="selectedCategory">管理不公</ToggleRadioItem>
          <div class="desc-tip" style="margin-left: 11px;color: darkgray;">管理不公（绩效、任务、奖惩、职场态度等）</div>
          <div class="sub-group" v-if="selectedCategory === 1">
            <div style="display: flex;flex-direction: column;">
              <ToggleRadioItem v-for="(opt, i) in subOptions1" :key="'c1-'+opt.id" :name="opt.id" v-model="selectedSubId">{{ opt.value }}</ToggleRadioItem>
            </div>
          </div>

          <ToggleRadioItem :name="2" v-model="selectedCategory">平台数据泄露</ToggleRadioItem>
          <div class="desc-tip" style="margin-left: 11px;color: darkgray;">平台商家数据泄露（外传、滥用、留存等）</div>
          <div class="sub-group" v-if="selectedCategory === 2">
            <div style="display: flex;flex-direction: column;">
              <ToggleRadioItem v-for="(opt, i) in subOptions2" :key="'c2-'+opt.id" :name="opt.id" v-model="selectedSubId">{{ opt.value }}</ToggleRadioItem>
            </div>
          </div>

          <ToggleRadioItem :name="3" v-model="selectedCategory">谋取私利</ToggleRadioItem>
          <div class="desc-tip" style="margin-left: 11px;color: darkgray;">谋取私利（收礼、分成、资源倾斜等）</div>
          <div class="sub-group" v-if="selectedCategory === 3">
            <div style="display: flex;flex-direction: column;">
              <ToggleRadioItem v-for="(opt, i) in subOptions3" :key="'c3-'+opt.id" :name="opt.id" v-model="selectedSubId">{{ opt.value }}</ToggleRadioItem>
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="req-title" style="margin-top:10px;"><span class="asterisk">*</span> 请具体描述投诉内容</div>
        <van-field
          style="font-size:110%;max-height: 65px;overflow: auto;"
          v-model="ticketNew.orderContent"
          type="textarea"
          maxlength="999" 
          show-word-limit
          rows="2"
          autosize
          placeholder="请填写投诉内容"/>
      </div>
      
      <div class="section">
        <div class="req-title"><span class="asterisk">*</span> 请上传投诉凭证</div>
        <MobileTicketUploadBig ref="up6"/>
      </div>
      <MobileSubmitButton @click="newTicket_1" ref="subBtn_1" style="transform: translateX(-50%);left:50%;margin-top: 30px;">提交</MobileSubmitButton>
      <!-- 单纯撑高一下  -->
      <div style="height:15vh;"></div>
    </div>
</template>

<script>
import { validatePlainText } from '@/assets/utils/TicketInputValidator';

export default {
    name : 'MobileTicketComplaintNew',
    data () {
        return {
        ticketNew : {
            orderType : [], // 意见反馈类型固定为 999
            orderContent : "",
            attachmentList : [],
            orderTitle : ""
        },
        selectedCategory: null,
        selectedSub: [],
        selectedSubId: null,
        subOptions1: [
          { id: 1102, value: '在客服任务分配、报酬核定、绩效考核等方面滥用管理权力，谋取私利；' },
        ],
        subOptions2: [
          { id: 1111, value: '利用数据查看权限，私存、外传客户相关经营数据，造成数据泄露；' },
          { id: 1112, value: '向外部或非授权人员泄露公司客户信息、客服信息、经营数据等敏感信息；' }
        ],
        subOptions3: [
          { id: 1121, value: '与客户、客服或其他合作方私下建立联系，进行有损公司利益的行为；' },
          { id: 1122, value: '未经报备向商家、或其他合作方索要或收取好处；' },
          { id: 1123, value: '向客服索要或收取任何好处；' },
        ]
        }
    },

    created() {
        if ( !!this.$route.query.ticketType ) {
            this.ticketNew.orderType = this.$route.query.ticketType;
        }
    },

    watch: {
        selectedCategory(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.onCategoryChange();
            }
        }
    },
    methods : {
        onCategoryChange() {
            this.selectedSub = [];
            this.selectedSubId = null;
        },
        newTicket_1() {
            const subMap = {
              1: this.subOptions1,
              2: this.subOptions2,
              3: this.subOptions3
            };
            const pickedIdNum = this.selectedSubId != null ? Number(this.selectedSubId) : null;
            const list = subMap[this.selectedCategory] || [];
            const picked = list.find(o => o.id === pickedIdNum);
            this.ticketNew.orderTitle = picked ? picked.value : '';
            this.ticketNew.orderType = pickedIdNum;
            this.ticketNew.attachmentList = this.$refs.up6.getAttachmentList();

            // validate required fields
            if (!this.ticketNew.orderTitle) {
              _notify('请选择你想投诉的问题');
              return;
            }
            if (!this.ticketNew.orderType) {
              _notify('请选择具体的投诉子项');
              return;
            }
            const contentResult = validatePlainText(this.ticketNew.orderContent, {
              required: true,
              maxLength: 999,
              requiredMessage: '请具体描述投诉内容'
            });
            if (!contentResult.valid) {
              _notify(contentResult.message);
              return;
            }
            this.ticketNew.orderContent = contentResult.value;
            if (!this.ticketNew.attachmentList || this.ticketNew.attachmentList.length === 0) {
              _notify('请上传投诉凭证');
              return;
            }

            var _this = this;
            _this.$refs.subBtn_1.disable();

            _this.$http.post("/ticket/v2-workOrder/create", _this.ticketNew).then( response => {
                    _this.$refs.subBtn_1.enable();

                    if ( !!response.data.status ) { // 成功
                        _this.$refs.up6.setAttachmentList([]);

                        // _this.$router.push({path:"/ticket-vue/v"});
                        _this.$emit('ticket-created');
                        return;
                    }

                    console.log('#97 workOrder/create then', response);

                    _notify('create error ' + response.data.message);
                }, response => {
                    _this.$refs.subBtn_1.enable();

                    console.log("#22 ", response);
                }
            );
        }
    }
}
</script>

<style lang="less" scoped>
.btn-blue {
  background-color: #77A9FD;
  border: 1px solid #77A9FD;
  width: 47vw;
}
.section { padding: 0 10px; }
.req-title { font-size: 16px; color: #111; margin: 8px 10px; }
.asterisk { color: #f44; margin-right: 4px; }
.desc-tip { color: #f44; font-size: 12px; margin: 2px 10px 8px; }
.sub-group { padding: 6px 10px 10px 28px; }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketComplaintNew.vue